import {
  START_LOADING,
  STOP_LOADING,
  SUCCESS,
  GET_BILLING_REQUESTS_TYPES,
} from "../types/index";
import * as api from "../api/index.js";

export const getBillingResquestsList =
  (page, limit, parameter, sort) => async (dispatch) => {
    try {
      dispatch({ type: START_LOADING });
      let query = "";
      if (parameter.billStatus != null && parameter.billStatus !== "") {
        query += `status=${encodeURIComponent(parameter.billStatus)}`;
      } else if (parameter.postingStatus === "true") {
        query += `Posted=true`;
      } else if (parameter.postingStatus === "false") {
        query += `Posted=false`;
      }
      if (parameter.fromDate) {
        query += `${query ? "&" : ""}fromDate=${parameter.fromDate}`;
      }
      if (parameter.toDate) {
        query += `${query ? "&" : ""}toDate=${parameter.toDate}`;
      }

      if (parameter.matterId) {
        query += `${query ? "&" : ""}MatterId=${parameter.matterId}`;
      }

      let orderby = "matterRef";
      if (sort?.field) {
        orderby = sort.dir === "desc" ? `${sort.field} desc` : sort.field;
      }
      query += `${query ? "&" : ""}orderby=${encodeURIComponent(orderby)}`;

      const datas = await api.getBillRequestsList(page, limit, query);

      dispatch({ type: GET_BILLING_REQUESTS_TYPES, payload: datas.data });

      dispatch({ type: STOP_LOADING });
      dispatch({ type: SUCCESS, payload: datas.message });
    } catch (error) { }
  };
